import { Pipe, PipeTransform } from '@angular/core';
/*
 * Takes a string and format acordinly to format
 * Format options: cpf, cnpj, rg
 * Usage:
 *   usuario | docFormat:format
 * Example:
 *   {{ 12345678900 | format:'cpf' }}
 *   formats to: 123.456.789-00
*/
@Pipe({name: 'docFormat'})
export class DocFormatPipe implements PipeTransform {
  transform(doc: string, format?: string): string {
    if ( ! doc ) {
      return doc;
    }

    switch( format ) {
      case "rg":
        return this.rgFormat( doc );
      case "cpf":
        return this.cpfFormat( doc );
      case "cnpj":
        return this.cnpjFormat( doc );
      default:
        return doc
    }
  }

  rgFormat( doc: string ): string {
    return doc.replace(/^(\d{2})(\d{3})(\d{3})(\w{2}).*/, '$1.$2.$3-$4');
  }

  cpfFormat( doc: string ): string {
    return doc.replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4');
  }

  cnpjFormat( doc: string ): string {
    return doc.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5');
  }
}
